import { render, staticRenderFns } from "./selectMerchant.vue?vue&type=template&id=f354fd48&"
import script from "./selectMerchant.vue?vue&type=script&lang=js&"
export * from "./selectMerchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports